import { GlobalNotificationStatus } from "@nova/component-global-notification"
import { setGlobalNotificationContext } from "user/profile/slice"
import { parseMmaCsvFiles } from "./parseMmaCsv"
import { mergeFlightCsv } from "./registry"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ActionCreator = (flightId: string) => any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Dispatch = (action: any) => unknown

/**
 * Builds the `attachCsvFiles` thunk for a multifile-upload slice. The registry
 * and parsing are shared; the two injected action creators are slice-specific:
 *
 * - `markFlightHasCsv`  — flags the flight as having telemetry (UI gating).
 * - `signalCsvReady`    — fires the slice's "csv" signal so files waiting on it
 *   (PNG/.owi conversions) can proceed.
 */
export const makeAttachCsvFiles =
    (deps: { markFlightHasCsv: ActionCreator; signalCsvReady: ActionCreator }) =>
    (flightId: string, csvFiles: File[]) =>
    async (dispatch: Dispatch) => {
        const rows = await parseMmaCsvFiles(csvFiles)
        if (rows.size === 0) {
            dispatch(
                setGlobalNotificationContext({
                    message:
                        "Telemetry CSV could not be read. Check that it is a valid MMA telemetry file.",
                    status: GlobalNotificationStatus.error,
                    timeoutInMs: 2000,
                })
            )
            return
        }
        mergeFlightCsv(flightId, rows)
        dispatch(deps.markFlightHasCsv(flightId))
        dispatch(deps.signalCsvReady(flightId))
    }
